import { CastReceiverContext } from 'chromecast-caf-receiver/cast.framework';
import { Event as SystemEvent } from 'chromecast-caf-receiver/cast.framework.system';
import { Logger } from '../logger';

/**
 * Debug channel — receives commands from the sender QA tool to toggle
 * the on-device debug overlay.
 *
 * **Protocol:**
 * Sender sends `{ command: "toggleLogs" }` on namespace
 * `urn:x-cast:br.com.brasilparalelo.debug`.
 */

const LOG_TAG = 'DEBUG_CHANNEL';

export const DEBUG_CHANNEL_NAMESPACE =
  'urn:x-cast:br.com.brasilparalelo.debug';

interface DebugMessage {
  command: string;
}

export function registerDebugChannel(
  context: CastReceiverContext,
): void {
  context.addCustomMessageListener(
    DEBUG_CHANNEL_NAMESPACE,
    (event: SystemEvent) => {
      const data = event.data as DebugMessage | undefined;

      if (!data?.command) {
        Logger.warn(LOG_TAG, 'Received message without command', { data });
        return;
      }

      switch (data.command) {
        case 'toggleLogs':
          Logger.toggleDOMOverlay();
          Logger.info(LOG_TAG, 'Debug overlay toggled');
          break;
        default:
          Logger.warn(LOG_TAG, `Unknown command: ${data.command}`);
      }
    },
  );

  Logger.info(LOG_TAG, 'Debug channel registered');
}
